import { render, staticRenderFns } from "./PortalDoClienteRoute.vue?vue&type=template&id=758701cb"
import script from "./PortalDoClienteRoute.vue?vue&type=script&lang=js"
export * from "./PortalDoClienteRoute.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports